import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsActivityList, goodsActivityCreate, goodsActivityUpdate, deleteGoodsActivity, goodsActivityStatus, getSellerList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import GoodsSelectComponent from '@/view/bianlidianManage/goods/goodsSelectComponent';

var _this;

export default {
  name: 'RegisterRecord',
  components: {
    GoodsSelectComponent: GoodsSelectComponent
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getGoodsActivityList,
      type: '',
      sellerOptions: [],
      shopRuleTypeOptions: [],
      multipleSelection: [],
      fullGiveDialogVisible: false,
      viewFullGiveDialogVisible: false,
      dialogTitle: '',
      dateRangeValueArr: [],
      goodsComponentFormData: {
        goodsType: '',
        dialogVisible: false,
        sellerId: '',
        selection: [],
        //回显，如果有数据，组件默认勾选
        activityGoodsMoney: '0'
      },
      formData: {},
      publicRules: {
        sellerId: [{
          required: true,
          message: '请选择商店',
          trigger: 'blur'
        }],
        activityName: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        dateRangeValueArr: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.dateRangeValueArr.length !== 2) {
              callback(new Error('请选择时间范围'));
            } else {
              callback();
            }
          }
        }]
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      debugger;

      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    }
  },
  computed: {
    getRule: function getRule() {
      return this.publicRules;
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('goodsActivity init');
                _context3.next = 3;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 3:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;
                _context3.next = 7;
                return _this3.getDict('shopRuleType');

              case 7:
                _this3.shopRuleTypeOptions = _context3.sent;
                _this3.formData = _this3.initData();
                _this3.searchInfo.shopActivityType = _this3.formData.shopActivityType;

                _this3.getTableData();

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        sellerId: '',
        sellerName: '',
        activityName: '',
        ruleType: 1,
        ruleTypeSub: 1,
        //写死
        startTime: '',
        endtime: '',
        isAllGoods: 1,
        //写死
        ruleRemark: '',
        moneySource: 2,
        //写死
        discountLevel: 1,
        //写死
        shopActivityType: 1,
        //写死
        activityRuleList: [this.initActivityRuleSingle()],
        activityGoodsList: [] //满赠商品

      };
      return formdata;
    },
    initActivityRuleSingle: function initActivityRuleSingle() {
      return {
        limits: '',
        discount: '',
        discountMax: '',
        extraAddmoney: '',
        onePrice: ''
      };
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.shopActivityType = this.formData.shopActivityType;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {
        shopActivityType: this.formData.shopActivityType
      };
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 选择商品-确定
    goodsSelDialogOk: function goodsSelDialogOk(res) {
      debugger;
      var that = this;
      that.goodsComponentFormData.dialogVisible = false;

      if (res && res.length > 0) {
        res.forEach(function (item) {
          if (that.goodsComponentFormData.goodsType == 'giveGoods') {
            that.formData.activityGoodsList.push(item);
          }
        });
      }
    },
    // 选择商品-关闭
    goodsSelDialogClose: function goodsSelDialogClose() {
      this.goodsComponentFormData.dialogVisible = false;
    },
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.onView(row);
    },
    // 满赠
    onAddFullGive: function onAddFullGive() {
      this.type = 'addFullGive';
      this.fullGiveDialogVisible = true;
      this.dialogTitle = '新增加油满赠活动';
      this.formData.ruleType = 3;
    },
    onView: function onView(row) {
      var that = this;

      if (row.ruleType == 3) {
        that.type = 'viewFullGive';
        this.dialogTitle = '查看加油满赠活动';
        this.viewFullGiveDialogVisible = true;
      }

      this.handleViewOrUpdate(row);
    },
    onUpdate: function onUpdate(row) {
      debugger;
      var that = this;

      if (row.ruleType == 3) {
        that.type = 'updateFullGive';
        that.fullGiveDialogVisible = true;
        that.dialogTitle = '变更加油满赠活动';
      }

      that.handleViewOrUpdate(row);
      that.$forceUpdate();
    },
    handleViewOrUpdate: function handleViewOrUpdate(row) {
      debugger;
      var that = this;
      that.formData = JSON.parse(JSON.stringify(row)); //不能用以下写法，回显会不展示
      // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.startTime)
      // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.endTime)

      that.dateRangeValueArr = [that.$options.filters.formatDate(row.startTime), that.$options.filters.formatDate(row.endTime)];
      that.formData.startTime = that.$options.filters.formatDate(row.startTime);
      that.formData.endTime = that.$options.filters.formatDate(row.endTime);
      that.formData.sellerName = that.$options.filters.getSellerName(row.sellerId);
    },
    onAble: function onAble(row) {
      var that = this;
      debugger;
      goodsActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 1
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    onDisable: function onDisable(row) {
      var that = this;
      debugger;
      goodsActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 2
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    onDelete: function onDelete(row) {
      var that = this;
      debugger;
      deleteGoodsActivity({
        'activityNo': row.activityNo,
        'sellerId': row.sellerId
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 选择便利店
    onSellerChange: function onSellerChange() {
      debugger;
      var that = this; // eslint-disable-next-line eqeqeq

      if (that.formData.sellerId != that.goodsComponentFormData.sellerId) {
        that.formData.activityGoodsList = [];
      }

      this.$forceUpdate();
    },
    // 添加商品
    onAddGoods: function onAddGoods(goodsType) {
      debugger;
      var that = this;

      if (!that.formData.sellerId || that.formData.sellerId === '') {
        that.$message({
          type: 'warning',
          message: '请选择便利店'
        });
        return;
      }

      that.goodsComponentFormData.dialogVisible = true;
      that.goodsComponentFormData.sellerId = that.formData.sellerId;
      that.goodsComponentFormData.goodsType = goodsType;
    },
    // 删除赠品
    onDelGiveGoods: function onDelGiveGoods(row) {
      debugger;
      var that = this; // eslint-disable-next-line eqeqeq

      that.formData.giveGoodsList = that.formData.giveGoodsList.filter(function (item) {
        return item.ID != row.ID;
      });
      this.$forceUpdate();
    },
    closeDialog: function closeDialog() {
      this.fullGiveDialogVisible = false;
      this.viewFullGiveDialogVisible = false;
      this.type = '';
      this.dialogTitle = '';
      this.dateRangeValueArr = [];
      this.goodsComponentFormData = {
        dialogVisible: false,
        sellerId: '',
        selection: [],
        goodsType: '',
        activityGoodsMoney: '0'
      };
      this.activityRuleList = [this.initActivityRuleSingle()];
      this.formData = this.initData();
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;
      debugger;

      switch (that.type) {
        case 'addFullGive':
          that.handleAdd('fullGiveFormData');
          break;

        case 'updateFullGive':
          that.handleUpdate('fullGiveFormData');
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd(refFormData) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                debugger;
                that.$refs[refFormData].validate(function (valid) {
                  if (valid && that.validFormData()) {
                    debugger;
                    goodsActivityCreate(that.getParam()).then(function (res) {
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 变更保存
    handleUpdate: function handleUpdate(refFormData) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                debugger;
                that.$refs[refFormData].validate(function (valid) {
                  debugger;

                  if (valid && that.validFormData()) {
                    debugger;
                    goodsActivityUpdate(that.getParam()).then(function (res) {
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    //公共校验函数
    validFormData: function validFormData() {
      var that = this;

      if (that.formData.activityGoodsList.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择赠品'
        });
        return false;
      }

      return true;
    },
    getParam: function getParam() {
      var that = this;
      var formData = JSON.parse(JSON.stringify(that.formData));
      formData.startTime = that.dateRangeValueArr[0];
      formData.endTime = that.dateRangeValueArr[1];
      formData.isAllGoods = 1;
      formData.ruleTypeSub = 1;
      formData.moneySource = 2;
      formData.discountLevel = 1;
      formData.shopActivityType = 1; // 规则

      if (that.formData.activityRuleList && that.formData.activityRuleList.length > 0) {
        formData.activityRuleList.forEach(function (item) {
          item.activityNo = that.formData.activityNo;
        });
      } // 活动赠品


      var activityGoodsList = [];

      if (formData.activityGoodsList && formData.activityGoodsList.length > 0) {
        formData.activityGoodsList.forEach(function (item) {
          item.activityGoodsType = 1;
          item.activityNo = that.formData.activityNo;
          delete item['ID'];
          activityGoodsList.push(item);
        });
      }

      formData.activityGoodsList = activityGoodsList;
      return formData;
    }
  }
};